/* eslint-disable @typescript-eslint/no-explicit-any */ const isObject = (obj)=>obj && typeof obj === 'object';
/**
 * Deeply merge nested objects; behavior compatible with lodash.merge
 *
 * @param target
 * @param source
 * @returns
 */ export const deepMerge = (target, source)=>{
    if (!isObject(target) || !isObject(source)) {
        return source;
    }
    Object.keys(source).forEach((key)=>{
        const targetValue = target[key];
        const sourceValue = source[key];
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
            target[key] = sourceValue;
        } else if (isObject(targetValue) && isObject(sourceValue)) {
            target[key] = deepMerge(Object.assign({}, targetValue), sourceValue);
        } else {
            target[key] = sourceValue;
        }
    });
    return target;
};

//# sourceMappingURL=deepMerge.js.map